module.exports = __webpack_public_path__ + "img/used-bg.e95f406e.png";